import React, { createContext, useReducer } from 'react'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case 'selected_pins': {
      let selected_pins = [...data.selected_pins]
      if (!selected_pins.includes(payload.data)) {
        selected_pins.push(payload.data)
        return { ...data, selected_pins: [...selected_pins] }
      } else {
        let selected_pins = data.selected_pins.filter(function (item) {
          return item !== payload.data
        })

        return { ...data, selected_pins: [...selected_pins] }
      }
    }
    case 'dtc_mapping_type': {
      return { ...data, dtc_mapping_type: payload.data }
    }

    case 'query_type': {
      return { ...data, query_type: payload.data }
    }
    case 'search_old_levels': {
      return { ...data, search_old_levels: payload.data }
    }
    case 'set_pins_filter_data': {
      return {
        ...data,
        selected_pins: payload.selected_pins,
        search_old_levels: payload.search_old_levels,
        query_type: payload.query_type,
        dtc_mapping_type: payload.dtc_mapping_type,
      }
    }
    case 'with_circuit_filters': {
      return { ...data, with_circuit_filters: payload.data }
    }
    case 'map_devices': {
      return { ...data, map_devices: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  selected_pins: [],
  dtc_mapping_type: 'start',
  query_type: 'db_level',
  search_old_levels: false,
  with_circuit_filters: false,
  map_devices: false,
}

const ConnectorPinsStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <ConnectorPinsContext.Provider value={[state, dispatch]}>
      {children}
    </ConnectorPinsContext.Provider>
  )
}

export const ConnectorPinsContext = createContext(initialState)
export default ConnectorPinsStore
